import { AbstractControl, ValidationErrors } from "@angular/forms";

export function ibanValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional fields
  }

  const iban = control.value.toString().trim();

  const cleanedIBAN = iban.replace(/\s/g, "").toUpperCase();

  // Basic IBAN format: 2 letters (country code) + 2 digits (check digits) + up to 30 alphanumeric characters
  const basicFormatRegex = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;

  if (!basicFormatRegex.test(cleanedIBAN)) {
    return { iban: true };
  }

  // Validate length (IBAN length varies by country, typically 15-34 characters)
  if (cleanedIBAN.length < 15 || cleanedIBAN.length > 34) {
    return { iban: true };
  }

  // Perform mod-97 checksum validation
  if (!validateIbanChecksum(cleanedIBAN)) {
    return { iban: true };
  }

  return null;
}

function validateIbanChecksum(iban: string): boolean {
  // Move first 4 characters to the end
  const rearranged = iban.slice(4) + iban.slice(0, 4);

  // Replace letters with numbers (A=10, B=11, ..., Z=35)
  const numericString = rearranged.replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());

  return mod97(numericString) === 1;
}

function mod97(numericString: string): number {
  let remainder = 0;
  for (const char of numericString) {
    remainder = (remainder * 10 + parseInt(char)) % 97;
  }
  return remainder;
}
